import Button from "@material-ui/core/Button";
import moment from "moment";
import React from "react";
import PrintIcon from "@material-ui/icons/Print";
import {
  List,
  Filter,
  TextField,
  Datagrid,
  SelectField,
  ChipField,
  DateField,
  DateInput,
  TextInput,
  SelectInput
} from "react-admin";
import { typeInvoice } from "../../constant/TypeInvoice";
import { HOST } from "../../configs/";
import Actions from '../Actions'

const InvoiceFilter = props => {
  return (
    <Filter {...props}>
      <DateInput alwaysOn source="date_lte" />
      <DateInput alwaysOn source="date_gte" />
      <TextInput source="no_invoice_contains" />
      <SelectInput source="type" choices={typeInvoice} />
      <TextInput source="name_contains" />
    </Filter>
  );
};

export const InvoiceList = props => {
  return (
    <List
      title="invoice.invoice"
      {...props}
      bulkActions={false}
      actions={<Actions />}
      filters={<InvoiceFilter />}
      filterDefaultValues={{
        date_gte: moment()
          .startOf("month")
          .format(),
        date_lte: moment()
          .endOf("month")
          .format()
      }}
    >
      <Datagrid>
        <div />
        <TextField source="no_invoice" />
        <SelectField
          source="type"
          optionText={<ChipField source="name" />}
          choices={typeInvoice}
        />
        <TextField source="name" />
        <DateField
          source="date"
          options={{ day: "numeric", month: "long", year: "numeric" }}
          locales="th-TH"
        />
        <PrintButton />
      </Datagrid>
    </List>
  );
};

class PrintButton extends React.Component {
  state = {};
  render() {
    const {
      record: {
        file: { url }
      }
    } = this.props;
    return (
      <Button
        onClick={() => window.open(HOST + url, "_blank")}
        primary="true"
        style={{ color: "#3f51b5" }}
      >
        <PrintIcon style={{ marginRight: 10 }} />
        Print
      </Button>
    );
  }
}

export default PrintButton;



// WEBPACK FOOTER //
// ./src/components/invoice/InvoiceList.js